import {
  type ReferentialTaskEntity,
  ReferentialTaskSchema
} from '@/core/infrastructure/schemas/referential/task/ReferentialTaskSchema.ts'
import { Quiz } from '@/core/domain/quiz/Quiz.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export class ReferentialTask {
  id: number
  title: string
  order: number
  quizStart: Quiz | null
  quizEnd: Quiz | null

  constructor(task: ReferentialTaskEntity) {
    this.id = task.id
    this.title = task.title
    this.order = task.order

    // Traitement sécurisé de la propriété quiz
    this.quizStart = null
    if (task.quizStart) {
      try {
        this.quizStart = Quiz.create(task.quizStart)
      } catch (error) {
        console.warn(
          `Impossible de créer un quiz à partir des données de la tâche ${task.id}:`,
          error
        )
      }
    }

    this.quizEnd = null
    if (task.quizEnd) {
      try {
        this.quizEnd = Quiz.create(task.quizEnd)
      } catch (error) {
        console.warn(
          `Impossible de créer un quiz à partir des données de la tâche ${task.id}:`,
          error
        )
      }
    }
  }

  public static create(data: unknown): ReferentialTask {
    return EntityValidator.validateAndCreate(
      ReferentialTaskSchema,
      data,
      ReferentialTask,
      'ReferentialTask'
    )
  }
}
